module.exports = __webpack_public_path__ + "img/about_main.870bd135.png";